export const environment = {
  backendUrl: 'http://geekeno-prod-wsgi-1:8000',
  baseUrl: 'https://geekeno.com',
  razorpayKey: 'rzp_live_ReJW8HxkgzRVr7',
};
